<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4 p-p-2">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Email Accounts') }}</div>
            <div class="p-p-1">
              <AddNewButton
                  :disabled="dataTableIsLoading"
                  :loading="dataTableIsLoading"
                  :label="$t('Add')"
                  @click="addNewItem"/>
            </div>
          </template>
        </Toolbar>

        <Spinner v-if="isLoading"/>
        <DesktopDataTable v-else
                          :showHeader="false"
                          :dataTableIsLoading="dataTableIsLoading"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
              {name: 'username', title: $t('Email'), sortable: false},
              {name: 'sender_name', title: $t('Sender Name'), sortable: false},
              {name: 'smtp_server', title: 'SMTP server', sortable: false},
              {name: 'smtp_port', title: 'SMTP port', sortable: false},
              // {name: 'imap_server', title: 'IMAP', sortable: false},
              {name: 'created_at', title: $t('Created'), sortable: true},
          ]">
          <template v-slot:body>
            <tr v-for="item of items"
                :key="item.id"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>
                <span v-if="item.username">{{ item.username }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.sender_name">{{ item.sender_name }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.smtp_server">{{ item.smtp_server }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <span v-if="item.smtp_port">{{ item.smtp_port }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td class="table-date-line">
                 <span v-if="item.created_at">
                   {{ formatBy(item.created_at, item.creator) }}
                 </span>
                <i v-else class="ti-minus"/>
              </td>

              <td v-show="actionButtonsCount">
                <div class="actions">
                  <EditButton @click="editItem(item)" :disabled="dataTableIsLoading"/>

<!--                  <DeleteButton  @click="confirmItemDelete(item)"-->
<!--                                :disabled="dataTableIsLoading"/>-->
                </div>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>

        <EmailAccountModal :visible="itemModal"
                           :item="item"
                           api-link="email-account-system"
                           :outgoingOnly="true"
                           @update-items="updateItems"
                           @close="closeItemModal"/>

<!--        <ConfirmDeleteModal :visible="confirmItemDeleteModal"-->
<!--                            :modalDataIsLoading="modalDataIsLoading"-->
<!--                            @close="closeConfirmItemDeleteModal"-->
<!--                            @delete-item="deleteItem"-->
<!--                            :data="itemToDeleteData"/>-->

			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import EmailAccountModal from "@/pages/account/components/EmailAccountModal";
import formatMixins from "@/mixins/formatMixins";
import datatableMixins from "@/mixins/datatableMixins";
import httpMixins from "@/mixins/httpMixins";
import settings from "@/settings";

export default {
  mixins: [ formatMixins, datatableMixins, httpMixins ],
  components: { EmailAccountModal },
	data() {
    return {
      fieldsExpand: 'creator',
      apiLink: 'email-account-system',
      routePath: '/system-email-accounts',
      searchData: '',
      sort: {
        column: 'id',
        direction: '-',
      },
    }
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
	},
  methods: {
    getPageData() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.getItems()
    },

    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('systemEmailAccounts')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.searchData,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })


        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.isLoading = false
        this.dataTableIsLoading = false
        if (this._abortors?.systemEmailAccounts === ctrl) {
          this._abortors.systemEmailAccounts = null
        }
      }
    },
	},
  computed: {
    actionButtonsCount() {
      return 1
    },
    // itemToDeleteData() {
    //   return  this.itemToDelete?.username ?? null
    // },
  }
}
</script>